module.exports = __webpack_public_path__ + "static/media/affiliate-icon.45453eb2.png";